export const colorWhite = '#fff';
export const colorBodyBG = '#e9ebee';

export const colorBlack = '#000';
export const colorBlack900 = '#111512';
export const colorBlack700 = '#666666';
export const colorBlack300 = '#454D49';
export const colorBlack200 = '#696F6B';
export const colorBlack100 = '#f2f3f2';
export const colorBlack500 = '#1E2621';

export const colorSurfaceLow = '#F6F5F8';
export const colorGrey = '#93a4ac';
export const colorGrey50 = '#F2F6FA';
export const colorGrey100 = '#E6E6E6';
export const colorGrey200 = '#CACCCB';
export const colorGrey300 = '#A8B0AC';
export const colorGrey400 = '#87928C';
export const colorGrey700 = '#576275';
export const colorGrey800 = '#464F5F';
export const colorGray900 = '#2d2d2d';
export const colorGrayLighten10 = '#e4eaf4';
export const colorGrayLighten300 = '#F2F5F8';

export const colorPrimary = '#35A47C';
export const colorPrimary50 = '#F3FAF7';
export const colorPrimary100 = '#E2F6FF';
export const colorPrimary200 = '#76C1A6';
export const colorPrimary300 = '#55B391';
export const colorPrimary400 = '#35A47C';
export const colorPrimary600 = '#4299E2';
export const colorPrimary800 = '#147DC2';
export const colorPrimary900 = '#19553E';

export const colorAccent = '#244696';
export const colorAccent250 = '#F6F5F8';
export const colorAccent2100 = '#D8D6E4';
export const colorAccent2900 = '#2E2A47';
export const colorLink400 = '#5076c0';
export const colorAccentLighten200 = '#5075C0';
export const colorAccentLighten100 = '#95a4ac';
export const colorAccentLighten50 = '#7788b0';
export const colorAccentLighten20 = '#ecf0f7';

export const colorSecondary = '#df3014';
export const colorSecondaryDarken10 = '#c92b12';
export const colorSecondaryLighten20 = '#e55943';
export const colorGrayLighten20 = '#575757';

export const colorSecondary100 = '#f5c1b8';
export const colorSecondary50 = '#FDF3F1';
export const colorSecondary200 = '#E97360';
export const colorSecondary400 = '#df3115';
export const colorSecondary500 = '#d32b12';
export const colorSecondary700 = '#BA210E';
export const colorSecondary900 = '#93180A';

export const colorAccent400 = '#fac917';
export const colorAccent100 = '#FEF0C7';
export const colorAccent1 = '#BEE4BA';
export const colorAccent1400 = '#F5C142';
export const colorAccent1600 = '#B38C2E';
export const colorAccent3 = '#369D23';
export const colorAccent50 = '#FEF9E9';
export const colorBorder = '#E5E5E5';
export const colorBlueGray = '#cdd7e7';
